export const PCPS_EVENTS: {
    date: string;
    title: string;
    venu?: string;
    to_date?: string;
    description?: string;
    time?: string;
    by?: string;
}[] = [
    {
        date: "2026-10-05",
        to_date: "2026-10-09",
        title: "TBD", // Coders Community — name to be announced
        venu: "PCPS College",
        by: "Coders Community",
    },
    {
        date: "2026-10-01",
        to_date: "2026-10-02",
        title: "RoboVision",
        venu: "PCPS College",
        by: "Innovators Community",
    },
    {
        date: "2026-09-24",
        title: "Denim Reimagined",
        venu: "PCPS College",
        by: "Entrepreneurship Community",
    },
    {
        date: "2026-09-17",
        to_date: "2026-09-18",
        title: "Efootball Tournament",
        venu: "PCPS College",
        by: "Champions Community",
    },
    {
        date: "2026-09-10",
        title: "Teej Unplugged",
        venu: "PCPS College",
        by: "Artist Community",
    },
    {
        date: "2026-07-22",
        to_date: "2026-07-23",
        title: "Career Connect",
        venu: "PCPS College",
    },
    {
        date: "2026-07-27",
        to_date: "2026-07-28",
        title: "Futsal Tournament",
        venu: "PCPS College",
    },
    {
        date: "2026-07-31",
        title: "Upstart Market Simulation",
        venu: "PCPS College",
    },
    {
        date: "2026-07-07",
        title: "Graduation Ceremony",
        venu: "Soltee Hotel",
    },
    {
        date: "2026-07-15",
        to_date: "2026-07-20",
        title: "Upstart",
    },
    {
        date: "2026-06-29",
        title: "DGO World Cup Engagement",
        venu: "PCPS College",
    },
    {
        date: "2026-04-6",
        to_date: "2026-04-09",
        title: "Into the Industry: Jiri Edition",
    },
    {
        date: "2026-03-29",
        to_date: "2026-04-03",
        title: "Sports Week",
        venu: "PCPS College",
    },
    {
        date: "2026-03-27",
        title: "1st Demo Pitch",
        venu: "PCPS College",
    },
    {
        date: "2026-02-23",
        title: "Basketball League 1",
        venu: "Basketball Court",
        by: "Champions Community",
        time: "11:00 AM"
    },
    {
        date: "2026-02-27",
        title: "Holi Umanga",
        venu: "PCPS College",
        time: "10:30 AM Onwards",
        by: "PCPS Community"
    },
    {
        date: "2026-03-09",
        title: "Upstart - Incubation",
        venu: "Learning Hub",
        time: "1:00 PM Onwards",
        by: "College x Entrepreneur Community"
    },
    {
        date: "2026-02-17",
        title: "PCPS Community presents BasketBall League",
        venu: "PCPS College",
    },
    {
        date: "2026-02-16",
        title: "Upstart - Concept Preparation",
        venu: "PCPS College",
        time: "3:00 Pm"
    },
    {
        date: "2026-01-30",
        title: "Pubg Tournament",
        venu: "PCPS",
        to_date: "2026-01-31",
        description: "Exciting campus tournament with cash prize for winners. Open to all students. Registration at the office.",
        time: "1:45 PM - 5:00 PM"
    },
    {
        date: "2026-01-29",
        title: "Community Inauguration",
        venu: "PCPS",
    },
]